
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { admission_returndata } from 'src/types/admission_returndata';
import { GlobalService } from '../_services/global.service';
import { users_returndata } from 'src/types/user_returndata';

@Component({
  selector: 'app-admissions',
  templateUrl: './admissions.component.html',
  styleUrls: ['./admissions.component.css']
})
export class AdmissionsComponent implements OnInit {
  ListAdmissions: any;
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  DisabledClass: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  constructor(
    private http: HttpClient, 
    private appComp: AppComponent, 
    private router: Router, 
    private messageService: MessageService, 
    private confirmationService: ConfirmationService,
    private globalService: GlobalService) { 
    }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("ADMISSIONS", user)){
          this.AccessAllowed = true;

          this.globalService.setBCItem(['Admissions','/admission']);
          this.loadgrid(false);
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  confirm(AdmissionID) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to disable this admission, it may be used in a package?',
        accept: () => {
          this.disableData(AdmissionID);
        }
    });
  }

  disableData(AdmissionID)
  {
    this.http.delete(bmxurl + "/Admission/" + this.VenueID + "/" + AdmissionID).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded == true)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Admission successfully disabled'});
        this.router.navigateByUrl("/admissions");

        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Admission'});
    })
  }
  
  loadgrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "Admissionlist/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.ListAdmissions = (response as admission_returndata);

        if ((response as admission_returndata).messages.length > 0)
        {
          (response as admission_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error getting Admissions, error: ' + this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail: 'Error getting Admissions, error: ' + error.messages});
    });
  }

  editData(AdmissionID)
  {
    this.router.navigateByUrl("/admissionedit/" + AdmissionID);
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    this.http.delete(bmxurl + "/Admission/" + this.VenueID + "/" + element.admissionid).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded == true)
      {
        this.loadgrid(false);
      } 
    }, error => {
    
    })
    });
    
  }
  }

